import React from "react";

const ToastAlert = props => {
  const { style, title = "Notification", description = "" } = props;
  return (
    <div
      className={`st-toast-alert__wrapper ${style ? `st-toast-alert--${style}` : ""}`}
    >
      <div className="st-toast-alert__icon">
        {style === "error" ? (
          <i className="far fa-times"></i>
        ) : style === "success" ? (
          <i className="far fa-check"></i>
        ) : style === "warning" ? (
          <i>!</i>
        ) : (
          <i>i</i>
        )}
      </div>
      <div className="st-toast-alert__content">
        <h4>{title}</h4>
        {description}
      </div>
    </div>
  );
};

export const ToastCloseIcon = ({ closeToast }) => (
  <button className="st-toast-alert__close-icon" onClick={closeToast}>
    <i className="fal fa-times"></i>
  </button>
);

export default ToastAlert;
